import { Menu, MenuItem, MenuPopup, MenuTrigger, Text } from "@salestrak/ui";
import type { ReactElement } from "react";

import type { IssueRow } from "#app/lib/data";
import { useFormFillDialogActions } from "#app/lib/form-fill-dialog-context";
import {
  isFillableForm,
  isOfferedOn,
  useFormsStore,
} from "#app/lib/forms";

export function FormPickerMenu({
  issue,
  trigger,
  onOpenChange,
}: {
  issue: IssueRow;
  trigger: ReactElement;
  onOpenChange?: (open: boolean) => void;
}) {
  const { forms } = useFormsStore();
  const { open } = useFormFillDialogActions();
  const published = forms.filter(isFillableForm);
  const offered = published.filter((form) => isOfferedOn(form, issue));

  return (
    <Menu {...(onOpenChange ? { onOpenChange } : {})}>
      <MenuTrigger render={trigger} />
      <MenuPopup align="start">
        {offered.length === 0 ? (
          <MenuItem disabled>
            <Text size="sm">
              {published.length === 0
                ? "No published forms with questions yet"
                : "No forms are offered on this Project"}
            </Text>
          </MenuItem>
        ) : (
          offered.map((form) => (
            <MenuItem
              key={form.formId}
              onClick={() => open({ formId: form.formId, issue, kind: "new" })}
            >
              <Text size="sm">{form.name}</Text>
            </MenuItem>
          ))
        )}
      </MenuPopup>
    </Menu>
  );
}
